import axios from "axios";

export function verifyToken(token) {
  return axios.post(`${process.env.REACT_APP_ANTIAGING_API}api/token`, null, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}
